import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { AppSettings } from '../_models/app.settings';
 
@Injectable()
export class AuthGuard implements CanActivate {
 
    constructor(private router: Router, private localStorage:LocalStorageService) { }
 
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    	var user:any = this.localStorage.get('user');
    	var accesos:any = user ? user.accesos : false;
        
        if ( accesos ) {
        	var roles = route.data["roles"] as Array<string>;
        	var permitido = false;

        	for(var r = 0; r < roles.length && permitido == false; r++){

        		for(let i = 0; i < accesos.length && permitido == false; i++ ){
					let acceso = parseInt(accesos[i].permisos);
					permitido = (acceso & AppSettings.permisos[roles[r]]) != 0;
				}

        	}

            return permitido;
        }
        this.router.navigate(['/pages/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/_guards/auth.guard.ts